import React from 'react';

import Grid from '@material-ui/core/Grid';

import DashboardLayout from '../../layouts/dashboard';
import { DriversCreate } from '../../../components/Drivers/DriversCreate';

export const DriversCreatePage = () => {
  return (
    <DashboardLayout title={'Choferes'}>
      <Grid
        container
        spacing={0}
        direction="row"
        alignItems="flex-start"
        justifyContent="flex-start"
        style={{ minHeight: '100vh' }}
      >
        <Grid item xs>
          <DriversCreate />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};
